export default class ViewCounter {
  static storageKey = 'lachvegas-viewed-articles';
  static viewValidityMs = 7 * 24 * 60 * 60 * 1000;
  static enableAlreadyViewedCheck = false;

  constructor(element) {
    this.node = element;
    this.viewType = this.node.getAttribute('data-type') || 'post';
    this.viewId = this.node.getAttribute('data-id');
    this.countNode = this.node.querySelector('[data-view-count]');

    if (this.viewId && this.countNode) {
      this.recordAndLoad();
    }
  }

  async recordAndLoad() {
    if (!['post', 'story'].includes(this.viewType)) {
      console.error('Unable to load views: invalid content type.');
      return;
    }

    const id = encodeURIComponent(this.viewId);
    const articleKey = `${this.viewType}:${this.viewId}`;
    const alreadyViewed = ViewCounter.enableAlreadyViewedCheck
      && this.hasRecentView(articleKey);

    try {
      if (!alreadyViewed) {
        const action = this.viewType === 'story' ? 'save_story_view' : 'save_post_view';
        const addResponse = await fetch(`/api.php?action=${action}&id=${id}`, {
          cache: 'no-store'
        });

        if (!addResponse.ok) {
          throw new Error(`View API returned HTTP ${addResponse.status}`);
        }

        const data = await addResponse.json();
        if (data.success !== true) {
          throw new Error(data.message || 'View count could not be saved');
        }

        this.updateCount(data.views);

        if (ViewCounter.enableAlreadyViewedCheck) {
          this.saveView(articleKey);
        }
        return;
      }

      const response = await fetch(
        `/api.php?action=get_view_count&type=${encodeURIComponent(this.viewType)}&id=${id}`,
        {
          cache: 'no-store'
        }
      );

      if (!response.ok) {
        throw new Error(`View API returned HTTP ${response.status}`);
      }

      const data = await response.json();
      if (data.success !== true) {
        throw new Error(data.message || 'View count could not be loaded');
      }

      this.updateCount(data.views);
    } catch (error) {
      console.error('Unable to load post views:', error);
    }
  }

  updateCount(views) {
    if (Number.isFinite(Number(views))) {
      this.countNode.textContent = String(Number(views));
    }
  }

  hasRecentView(articleKey) {
    const views = this.readStoredViews();
    const expiresAt = Number(views[articleKey]);

    if (Number.isFinite(expiresAt) && expiresAt > Date.now()) {
      return true;
    }

    if (Object.prototype.hasOwnProperty.call(views, articleKey)) {
      delete views[articleKey];
      this.writeStoredViews(views);
    }

    return false;
  }

  saveView(articleKey) {
    const views = this.readStoredViews();
    views[articleKey] = Date.now() + ViewCounter.viewValidityMs;
    this.writeStoredViews(views);
  }

  readStoredViews() {
    try {
      const storedValue = window.localStorage.getItem(ViewCounter.storageKey);
      const views = storedValue ? JSON.parse(storedValue) : {};
      return views && typeof views === 'object' && !Array.isArray(views) ? views : {};
    } catch (error) {
      console.warn('Unable to read viewed articles from localStorage:', error);
      return {};
    }
  }

  writeStoredViews(views) {
    try {
      window.localStorage.setItem(ViewCounter.storageKey, JSON.stringify(views));
    } catch (error) {
      console.warn('Unable to save viewed article in localStorage:', error);
    }
  }
}
